/**
 * Transport for AI agent management. Thin wrappers over the single shared
 * `apiClient`; no mapping and no business rules.
 */
import type { AxiosResponse } from 'axios';
import apiClient from '../apiClient';
import { API_ENDPOINTS } from '../endpoints';
import type {
  AgentDetailsResponse,
  AgentResultResponse,
  AgentsListRequest,
  AgentsListResponse,
  DeleteAgentRequest,
  GetAgentRequest,
  PersonaListResponse,
} from './agentAdminTypes';

const agentAdminApi = {
  list: (payload: AgentsListRequest): Promise<AxiosResponse<AgentsListResponse>> =>
    apiClient.post(API_ENDPOINTS.AGENT.AGENTS_LIST, payload),

  details: (
    payload: GetAgentRequest,
  ): Promise<AxiosResponse<AgentDetailsResponse>> =>
    apiClient.post(API_ENDPOINTS.AGENT.AGENT_DETAILS, payload),

  /**
   * Create or edit. The endpoint is multipart, so the caller passes FormData
   * and Axios sets the boundary itself — setting Content-Type by hand drops it.
   */
  upsert: (form: FormData): Promise<AxiosResponse<AgentResultResponse>> =>
    apiClient.post(API_ENDPOINTS.AGENT.AGENT, form),

  setActive: (
    payload: DeleteAgentRequest,
  ): Promise<AxiosResponse<AgentResultResponse>> =>
    apiClient.delete(API_ENDPOINTS.AGENT.AGENT, { data: payload }),

  personas: (): Promise<AxiosResponse<PersonaListResponse>> =>
    apiClient.get(API_ENDPOINTS.AGENT.PERSONA_LIST),
};

export default agentAdminApi;
